import Api, { meisheApi } from './api'

export const remoteApi = () => {
  if (import.meta.env.VITE_CONFIG_NAME === 'meishe') {
    return meisheApi
  } else {
    return Api
  }
}
